"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFixNum = void 0;
// import { ReactNode } from 'react';
const js_big_decimal_1 = __importDefault(require("js-big-decimal"));
function formatFixNum(numberStr) {
    const formatted = /^[-+]?[0-9]+\.{0,1}[0-9]{0,}$/;
    if (formatted.test(numberStr)) {
        return js_big_decimal_1.default.getPrettyValue(numberStr, 3, ',');
    }
    return numberStr;
}
exports.formatFixNum = formatFixNum;
//# sourceMappingURL=format-fix-num.js.map